import { HttpParams } from '@angular/common/http';

export function toQueryParams<T>(request: T): HttpParams {
  const normalizedRequest = Object.keys(request ?? {}).reduce((result, key) => {
    const value = request[key];

    if (value === undefined) {
      result[key] = '';
      return result;
    }

    if (value === null) {
      result[key] = '';
      return result;
    }

    if (typeof value === 'string') {
      result[key] = value;
      return result;
    }

    if (typeof value === 'number') {
      result[key] = value.toString();
      return result;
    }

    if (typeof value === 'boolean') {
      result[key] = value.toString();
      return result;
    }

    if (value instanceof Date) {
      result[key] = value.toISOString();
      return result;
    }

    return result;
  }, {});

  return new HttpParams({
    fromObject: normalizedRequest
  });
}
